import { useTranslation } from 'react-i18next';

export default function ContactCTA() {
  const { t } = useTranslation();

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="rounded-2xl overflow-hidden mb-10">
          <img
            src="https://readdy.ai/api/search-image?query=Beautiful%20anime%20style%20illustration%20of%20cherry%20blossom%20trees%20in%20a%20peaceful%20garden%20with%20soft%20sunlight%2C%20pathway%20leading%20to%20a%20traditional%20building%2C%20warm%20pink%20and%20golden%20tones%2C%20inviting%20and%20serene%20atmosphere%2C%20clean%20composition%2C%20high%20quality%20anime%20background%20art&width=1400&height=600&seq=cta-about-contact&orientation=landscape"
            alt="联系樱花动漫"
            title="联系我们 - 樱花动漫"
            className="w-full h-auto object-cover"
            loading="lazy"
          />
        </div>

        <div className="text-center mb-8">
          <p className="text-xl md:text-3xl font-heading text-foreground-900 leading-relaxed mb-2">
            <em className="text-foreground-500 not-italic font-light">{t('合作联系')}</em>
          </p>
          <p className="text-xl md:text-3xl font-heading text-foreground-900 font-bold leading-relaxed mb-4">
            {t('联系我们开始合作')}
          </p>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto leading-relaxed">
            {t('合作联系文案')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto mb-8">
          <div className="bg-background-100 rounded-lg p-5 flex items-start gap-4">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
              <i className="ri-map-pin-line text-lg"></i>
            </div>
            <div>
              <h4 className="text-sm font-medium text-foreground-900 mb-1">{t('公司地址')}</h4>
              <p className="text-xs text-foreground-600 leading-relaxed">{t('公司地址内容')}</p>
            </div>
          </div>
          <div className="bg-background-100 rounded-lg p-5 flex items-start gap-4">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
              <i className="ri-phone-line text-lg"></i>
            </div>
            <div>
              <h4 className="text-sm font-medium text-foreground-900 mb-1">{t('联系电话')}</h4>
              <p className="text-xs text-foreground-600">020-88886666</p>
            </div>
          </div>
          <div className="bg-background-100 rounded-lg p-5 flex items-start gap-4">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
              <i className="ri-mail-line text-lg"></i>
            </div>
            <div>
              <h4 className="text-sm font-medium text-foreground-900 mb-1">{t('电子邮箱')}</h4>
              <p className="text-xs text-foreground-600">hello@kktyvqy.cn</p>
            </div>
          </div>
          <div className="bg-background-100 rounded-lg p-5 flex items-start gap-4">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
              <i className="ri-time-line text-lg"></i>
            </div>
            <div>
              <h4 className="text-sm font-medium text-foreground-900 mb-1">{t('工作时间')}</h4>
              <p className="text-xs text-foreground-600">{t('工作时间内容')}</p>
            </div>
          </div>
        </div>

        <div className="text-center">
          <a
            href="mailto:hello@kktyvqy.cn"
            className="inline-flex items-center gap-2 bg-foreground-900 text-background-50 px-8 py-3 rounded-full text-sm font-medium hover:bg-foreground-800 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-mail-send-line text-lg"></i>
            {t('联系我们')}
          </a>
        </div>
      </div>
    </section>
  );
}